import {Component, Input, OnInit} from '@angular/core';
import {SidebarItem} from './SidebarItem';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {I18NService} from '../../i18n/i18n.service';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-sidebar-item',
  templateUrl: './SidebarItem.component.html',
  styleUrls: ['./SidebarItem.component.css']
})
export class SidebarItemComponent implements OnInit {

  @Input()
  sidebarItem: SidebarItem;

  svg: SafeHtml;

  constructor(private sanitizer: DomSanitizer, private i18nService: I18NService) {}

  ngOnInit() {
    this.setSVGSize();
    this.setI18nTitle();
  }

  private setSVGSize() {
    if (this.sidebarItem.svgContent != null && this.sidebarItem.svgContent.includes('svg')) {
      const svgSize = this.sidebarItem.submenuLevel === 0 ? '19' : '14';
      const svgFormatted = this.sidebarItem.svgContent.replace('svg','svg' + ' width=' + svgSize + ' height=' + svgSize);
      this.svg = this.sanitizer.bypassSecurityTrustHtml(svgFormatted);
    }
  }

  private setI18nTitle() {
    if (this.sidebarItem.title == null && this.sidebarItem.titleId != null) {
      this.sidebarItem.title = this.i18nService.get(this.sidebarItem.titleId);
    }
  }
}
